import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import LungCung from './image/booking/lungcung.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: `6:30 PM`, description: `Tạm biệt phố thị, khởi hành đi Tú Lệ - Yên Bái` },
      { description: `Rời xa khói bụi Hà Nội, chúng ta bắt đầu hành trình tìm về phía đại ngàn. Hãy tự thưởng cho mình một giấc ngủ nhẹ trên xe để nạp lại năng lượng cho những điều tuyệt vời sắp tới.` },
      { time: `12:00 AM`, description: `Nghỉ ngơi tại homestay giữa thung lũng Tú Lệ` },
      { description: `Một giấc ngủ sâu trong không khí se lạnh của vùng cao là 'liều thuốc' tốt nhất. Hãy để cơ thể được nghỉ ngơi trọn vẹn, chuẩn bị cho một tâm hồn tỉnh táo và đôi chân vững chãi vào sáng mai.` }
    ],
  },
  {
    day: "Thứ 7 - Hành Trình Chinh Phục Thác Cổ & Đỉnh Cao",
    activities: [
      { time: `6:00 AM`, description: `Bữa sáng ấm áp với hương vị xôi nếp Tú Lệ` },
      { description: `Thưởng thức đặc sản nếp nương nổi tiếng để ngăn ngừa việc tụt đường huyết khi leo dốc. Bạn chỉ cần mang theo những đồ dùng cần thiết nhất lên đỉnh, còn lại hãy để chúng mình lo liệu và gửi lại homestay nhé.` },
      { time: `6:30 AM`, description: `Trải nghiệm cung đường xe máy xuyên bản làng` },
      { description: `Ngồi sau tay lái của các chàng trai bản địa, bạn sẽ được băng qua những con đường uốn lượn, nơi cơn gió Tây Bắc thổi tâm hồn tự do. Đừng quên lưu lại những tấm hình 'cực chill' khi đi ngang qua những triền ruộng bậc thang tầng tầng lớp lớp.` },
      { time: `8:30 AM`, description: `Bắt đầu những bước chân đầu tiên vào rừng già` },
      { description: `Hãy để các Porter - những người bạn đồng hành tận tụy - dẫn lối cho bạn. Nước uống, găng tay và áo mưa đã sẵn sàng, việc của bạn chỉ là hít thở thật sâu và tận hưởng vẻ đẹp của thiên nhiên.` },
      { time: `10:00 AM`, description: `Chiêm ngưỡng 'dải lụa trắng' Hấu Chua La` },
      { description: `Ngọn thác cổ tích hiện ra như một kiệt tác giữa rừng sâu với bọt tung trắng xóa và những tảng đá phủ rêu xanh mướt.` },
      { time: `11:30 AM`, description: `Dùng bữa trưa và giấc nghỉ ngắn giữa rừng` },
      { description: `Một chút thanh âm của tiếng suối reo và gió ngàn sẽ vỗ về giấc ngủ trưa 15 phút của bạn. Đây là lúc tâm hồn được thanh lọc và cơ bắp được phục hồi một cách kỳ diệu nhất.` },
      { time: `4:30 PM`, description: `Chạm đỉnh Lùng Cúng - Đứng trên thảo nguyên mây` },
      { description: `Chúc mừng bạn! Đứng giữa bãi cỏ phẳng lì như sân golf trên đỉnh núi, bạn sẽ thấy thế giới thật rộng lớn. Hãy tận hưởng khoảnh khắc này, chụp những bức ảnh 'để đời' khi ánh hoàng hôn bắt đầu nhuộm vàng cả biển mây.` },
      { time: `6:30 PM`, description: `Trở về lán nghỉ & Đêm tiệc bên bếp lửa` },
      { description: `Không sóng điện thoại, không thông báo công việc. Chỉ có hơi ấm của bếp lửa, mùi thơm của gà nướng và những câu chuyện thân tình. Một đêm 'Digital Detox' tuyệt vời để bạn kết nối sâu sắc hơn với chính mình.` }
    ],
  },
  {
    day: "Chủ Nhật - Bình Minh Rực Rỡ & Suối Khoáng Chữa Lành",
    activities: [
      { time: `6:00 AM`, description: `Đón những tia nắng đầu tiên trên đỉnh núi` },
      { description: `Khoảnh khắc những cột nắng xuyên qua sương sớm giữa rừng thưa là vẻ đẹp mà không ống kính nào lột tả hết được. Hãy để trái tim bạn được sưởi ấm bởi ánh bình minh rực rỡ trước khi bắt đầu hành trình trở về.` },
      { time: `8:00 AM`, description: `Tạm biệt lán nghỉ, thong dong xuống núi` },
      { description: `Chúng mình sẽ cùng bạn kiểm tra lại hành lý, đảm bảo mọi kỷ niệm đều được mang theo. Hãy thắt chặt dây giày và bước đi thong thả, nếu thấy mỏi chân, hãy cứ tựa vào vai những người đồng hành nhé.` },
      { time: `12:00 PM`, description: `Dùng bữa trưa cuối cùng tại vùng cao` },
      { description: `Nạp lại năng lượng sau hành trình dài với những món ăn bản địa nóng hổi, trước khi chúng ta nói lời chia tay với núi rừng để về với phố thị.` },
      { time: `1:30 PM`, description: `Xe máy đón bạn rời chân núi về lại Tú Lệ` },
      { time: `3:30 PM`, description: `Thả mình trong dòng suối khoáng nóng` },
      { description: `Đây là phần thưởng xứng đáng nhất: Ngâm mình trong làn nước khoáng nóng tự nhiên của Tú Lệ để xua tan mọi mệt mỏi, giúp làn da rạng rỡ và cơ bắp được thư giãn hoàn toàn sau chuyến đi.` },
      { time: `4:30 PM`, description: `Chào tạm biệt Yên Bái, lên xe về lại Thủ đô` },
      { description: `Kiểm tra lại những món quà vùng cao trong hành lý. Chuyến xe êm ái sẽ đưa bạn vào giấc ngủ ngon để trở về với Hà Nội trong trạng thái sảng khoái nhất.` },
      { time: `10:00 PM`, description: `Về đến Hà Nội - Kết thúc hành trình trọn vẹn` },
      { description: `Cảm ơn bạn đã tin tưởng đồng hành. Những ký ức đẹp đẽ về Lùng Cúng sẽ là nguồn năng lượng tích cực cho tuần làm việc mới của bạn. Hẹn gặp lại bạn ở những đỉnh cao tiếp theo!` }
    ],
  }
];

const LungCungSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>Lùng Cúng – “Ốc đảo trời” giữa Biển Mây Tây Bắc</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Lùng Cúng – ngọn núi cao 2.913 mét ở Yên Bái, không chỉ là cung đường thách thức ý chí, mà còn là “Ốc đảo trời” lãng mạn,
           nơi bạn sẽ được chiêm ngưỡng đại dương mây bồng bềnh 360 độ và đắm mình trong sự hùng vĩ, 
           hoang sơ của thiên nhiên Tây Bắc.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Nhóm bạn trẻ nằm thảnh thơi trên đỉnh Lùng Cúng
        </p>
        <img src={LungCung} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default LungCungSchedule;